import { useLazyQuery } from "@apollo/client";
import { DataCoreBaseProduct } from "@towersystems/roam-common/lib/generated-types";
import { QUERY_FIND_BASE_PRODUCT_BY_SKU } from "./constants";

export const useQueryFindBaseProductByBarcodeAsync = () => {
  const [q, { loading }] = useLazyQuery<{
    getBaseProductByBarcode: DataCoreBaseProduct | undefined;
  }>(QUERY_FIND_BASE_PRODUCT_BY_SKU);

  const useQueryFindBaseProductByBarcodeAsync = async (barcode: string) => {
    return q({
      variables: {
        barcode,
      },
    })
      .then((res) => {
        if (res.error?.graphQLErrors) {
          console.log(res.error);
          throw new Error(
            res.error.graphQLErrors[0]?.message ?? "common:error"
          );
        }
        return res.data?.getBaseProductByBarcode;
      })
      .catch((err) => {
        console.log("FINDME, err", err);
        throw new Error(err.message ?? "common:error");
      });
  };

  return { query: useQueryFindBaseProductByBarcodeAsync, loading };
};
